var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialFacebook = function SvgSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_625_61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12C0.5 17.6925 4.64 22.4075 10.1025 23.385L10.1705 23.3294C10.167 23.3288 10.1635 23.3281 10.16 23.3275V15.22H7.28501V12H10.16V9.47C10.16 6.595 12 4.985 14.645 4.985C15.45 4.985 16.37 5.1 17.175 5.215V8.1475H15.68C14.3 8.1475 13.955 8.8375 13.955 9.7575V12H17.0025L16.485 15.22H13.955V23.3275C13.92 23.3339 13.885 23.3401 13.8499 23.3461L13.8975 23.385C19.36 22.4075 23.5 17.6925 23.5 12C23.5 5.675 18.325 0.5 12 0.5C5.675 0.5 0.5 5.675 0.5 12Z",
    fill: "var(--on-surface)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_625_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export default SvgSocialFacebook;